import React, { useEffect, useState, useRef } from 'react'
import ImageNotAvailable from '../../../assets/image-not-available.png'
import PlayIcon from '../../../assets/Content-Icons/Svgs/play-circle.svg'
import SixDots from '../../../assets/six-dots.svg'
import SelectedTagIcon from '../../../assets/Content-Icons/Svgs/selected-tag-icon.svg'
import CustomImage from 'src/components/customImage/customImage'
import DeleteIcon from '../../../assets/Content-Icons/Svgs/delete-icon-cms.svg'

const CustomPreviewListCard = ({
  cardStyle = {},
  cardImage = '',
  fileName = '',
  rightText = '',
  duration = '',
  contentType = '',
  // category = '',
  categories = [],
  isSelectable = false,
  isSelected = false,
  actionButtonAction = null,
  disableHoverEffect = false,
  fileNameWidth = '20%',
  durationWidth = '10%',
  rightTextWidth = '10%',
  contentTypeWidth = '10%',
  categoriesWidth = '20%',
  removeSixDotIcon = false,
}) => {
  const elementRef = useRef([])
  const containerElementRef = useRef(null)
  const [contentCategories, setContentCategories] = useState(categories)

  const [extraCategories, setExtraCategories] = useState([])
  const [visibleCategories, setVisibleCategories] = useState([])

  useEffect(() => {
    let tempExtraCategory = []
    let tempExtraCategoryTexts = []
    let categoriesContainerWidth = containerElementRef.current.clientWidth // categories container width
    let categoriesWidths = elementRef.current.map((item) => item.clientWidth) // categories Width(s) array
    let categoriesTexts = elementRef.current.map((item) => item.innerHTML) // categories Text(s) array
    let getSumOfCategoriesWidth = () => categoriesWidths.reduce((a, b) => a + b, 0) // getter for sum of categories width(s)

    while (getSumOfCategoriesWidth() > categoriesContainerWidth) {
      tempExtraCategory.push(categoriesWidths.pop())
      tempExtraCategoryTexts.push(categoriesTexts.pop())
    }
    setVisibleCategories(categoriesTexts)
    setExtraCategories(tempExtraCategory)
  }, [])

  useEffect(() => {
    setContentCategories(visibleCategories)
  }, [visibleCategories])
  return (
    <div
      style={{
        width: '100%',
        aspectRatio: '1181/78',
        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        display: 'flex',
        justifyContent: 'center',
        background: '#ececec',
        gap: '0 .6%',
        padding: '.4vw 0vw',
        ...cardStyle,
      }}
      className={`${disableHoverEffect ? '' : 'on-card-hover'} on-card-selected rounded-2`}
      tabIndex={0}
      //   onClick={onSelect}
    >
      {!removeSixDotIcon && (
        <div style={{ width: '2%' }} className="d-flex justify-content-center align-items-center">
          <img src={SixDots} alt="" />
        </div>
      )}

      <div className="relative" style={{ height: '100%', width: '9%' }}>
        <CustomImage
          className="card-img-top"
          imageUrl={cardImage}
          loaderStyle={{ height: '100%' }}
          errorPlaceholder={ImageNotAvailable}
          alt={'Asset'}
          imgStyle={{ height: '100%', width: '100%', objectFit: 'cover' }}
        />
        {isSelectable && (
          <img
            src={SelectedTagIcon}
            alt=""
            className={`selected-tag ${isSelected ? 'selected-content' : ''}`}
          />
        )}
      </div>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ background: 'none', width: '85%', background: 'none' }}
      >
        <div
          style={{ fontSize: '12px' }}
          className="d-flex justify-content-between align-items-center w-100"
        >
          <p
            style={{
              marginBlockEnd: '0',
              fontWeight: '600',
              fontSize: '14px',
              width: fileNameWidth,
              background: 'none',
              marginLeft: '.5vw',
            }}
          >
            {fileName}
          </p>
          <p style={{ marginBlockEnd: '0', width: durationWidth, background: 'none' }}>
            {duration.includes(':') ? duration.replace(':', ' ') : duration}
          </p>
          <p style={{ marginBlockEnd: '0', width: rightTextWidth, background: 'none' }}>
            {rightText}
          </p>
          <p style={{ marginBlockEnd: '0', width: contentTypeWidth, background: 'none' }}>
            {contentType}
          </p>
          <p
            style={{
              marginBlockEnd: '0',
              width: categoriesWidth,
              marginRight: '-2%',
              whiteSpace: 'nowrap',
              flexShrink: '0',
            }}
            ref={containerElementRef}
          >
            {contentCategories.map((category, idx) => (
              <span
                style={{
                  background: '#d6d2d2',
                  padding: '.25ch 1ch',
                  borderRadius: '10px',
                  marginRight: '.5vw',
                  display: 'inline-block',
                }}
                ref={(el) => (elementRef.current[idx] = el)}
                key={idx}
              >
                {category}
              </span>
            ))}
            {extraCategories.length > 0 && <span>+{extraCategories.length}</span>}
          </p>
          <div
            style={{
              width: '3%',
              fontSize: '20px',
              fontWeight: '700',
              cursor: 'pointer',
            }}
            className="d-flex justify-content-center align-items-center position-relative preview-menu-dots"
          >
            {actionButtonAction && (
              <button
                style={{ border: 'none', outline: 'none', background: 'none' }}
                onClick={actionButtonAction}
              >
                <img src={DeleteIcon} alt="" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomPreviewListCard

/*
.on-card-hover - Applies the hover effect to the card
.on-card-selected - Applies the selected effect to the card
.play-icon - Applies the play icon effect to the card which is of type "video", it is absolute on the thumbnail (search for the class for more)

displayAsListItem - display the card as a list item(if true) or a grid item(if false)

publish_time - start
live_exp_tiem - end time

/////// for live
*/
